import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useEffect, useRef, useState } from 'react'
import { XMarkIcon } from '@heroicons/react/24/solid'
import { Button, InputField, Loader, Typography } from '@pw-tech/omni-ui'
import UserModal from '@assets/images/ambassdor/UserModal'
import { Client } from '@api/index'
import toast from 'react-hot-toast'
import { indiaDialCode, indianCountryCode } from '@utils/constants'
import OtpInputBoxes from '@components/Login/OTP./OtpInputBoxes'
import EditIcon from '@assets/images/ambassdor/Registration&login/EditIcon'
import Phone from '@assets/images/ambassdor/Phone'
import { PROGRAM_TYPE } from '@utils/enum'
import { useAmbassadorContext } from '@context/context'
import useValidateAssistedSalesCoupon from '@api/hooks/ambassador-batch/useValidateAssistedSalesCoupon'

const formatTime = (time: number) => {
  const minutes = Math.floor(time / 60)
  const seconds = time % 60
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(
    2,
    '0'
  )}`
}

export default function BatchUserModal({
  isOpen,
  onClose,
  selectedPlan,
  partPayment,
  batchType,
  handleBatchUserModal,
}: any) {
  const [userData, setUserData] = useState<any>({})
  const [timer, setTimer] = useState(10)
  const [resendDisabled, setResendDisabled] = useState(true)
  const [otpFail, setOtpFail] = useState(false)
  const [isProceed, setIsProceed] = useState<boolean>(false)
  const [isSendingOtp, setIsSendingOtp] = useState(false)
  const { myProfileValue } = useAmbassadorContext()
  const intervalRef = useRef<any>(null)
  const [urlSend, setUrlSend] = useState<boolean>(false)
  const [errors, setErrors] = useState({ name: '' })
  const { mutate } = useValidateAssistedSalesCoupon()

  useEffect(() => {
    if (selectedPlan) {
      localStorage.setItem('PLAN_DETAILS', JSON.stringify(selectedPlan))
    }
  }, [selectedPlan])

  const paymentGatewayScript = () => {
    const batchBuyUserId = localStorage.getItem('BATCH_BUY_USER_ID') || ''
    const coupanData = JSON.parse(localStorage.getItem('couponData') || '{}')
    const accessPhoneNumber =
      (localStorage.getItem('BUY_PHONE_NUMBER') as string) || ''
    let info: any = {
      batchSlug: selectedPlan?.batchId,
      cameFrom: 'batch-details',
      ambassadorDetails: {
        userId: batchBuyUserId,
        couponCode: coupanData?.couponCode,
        phoneNumber: accessPhoneNumber,
        userName: userData?.name || '',
        type:
          myProfileValue?.programType === PROGRAM_TYPE.CSC_PROGRAM
            ? 'AMBASSADOR_CSC'
            : 'AMBASSADOR',
      },
    }
    if (selectedPlan?._id) {
      info.planId = selectedPlan?._id
    }
    let base64Info = btoa(JSON.stringify(info))
    window.location.href = `/sales/order-summary?info=${base64Info}`
  }

  const paymentGatewayScriptForSkills = () => {
    const batchBuyUserId = localStorage.getItem('BATCH_BUY_USER_ID') || ''
    const couponData = JSON.parse(localStorage.getItem('couponData') || '{}')
    mutate(
      {
        couponCode: couponData?.couponCode,
        userId: batchBuyUserId,
        courseId: selectedPlan?.batchId,
      },
      {
        onSuccess: (data) => {
          let info: any = {
            courseId: selectedPlan?.batchId,
            cameFrom: 'skills',
          }

          let base64Info = btoa(JSON.stringify(info))
          window.location.href = `/sales/order-summary?info=${base64Info}`
          setUrlSend(true)
        },
        onError: (error: any) => {
          toast.error(
            error || 'validate Failed to validate coupon. Please try again.'
          )
          onClose()
        },
      }
    )
  }

  const getUser = async () => {
    try {
      const params: any = {
        phoneNo: userData?.phone || '',
        otp: Number(otp.join('')),
      }
      localStorage.setItem('BUY_PHONE_NUMBER', userData?.phone || '')
      localStorage.setItem('BUY_USER_NAME', userData?.name || '')
      const response = await Client.get(
        `${process.env.REACT_APP_PP_API_BASE_URL}/v1/student-acquisition/ambassador-client/user-details`,
        { params: params }
      )
      if (!response?.data?.data?._id) {
        createUser()
      } else {
        localStorage.setItem('BATCH_BUY_USER_ID', response?.data?.data?._id)
        updateUserCohort(response?.data?.data)
      }
    } catch (err: any) {
      toast.error(err?.message || 'Some error occured while fetching user')
    }
  }

  const createUser = async () => {
    try {
      const response = await Client.post(
        `${process.env.REACT_APP_PP_API_BASE_URL}v1/student-acquisition/ambassador-client/create-user`,
        {
          phoneNo: userData?.phone || '',
          firstName: userData?.name?.trim() || '',
          otp: Number(otp.join('')),
        }
      )
      if (response?.data?.success) {
        localStorage.setItem('BATCH_BUY_USER_ID', response?.data?.data?._id)
        updateUserCohort(response?.data?.data)
      }
    } catch (err: any) {
      toast.error(err?.message || 'Some error occured while creating user')
    }
  }

  const updateUserCohort = async (userDetails: any) => {
    const cohortId = localStorage.getItem('COHORT_ID') || ''
    try {
      const response = await Client.put(
        `${process.env.REACT_APP_PP_API_BASE_URL}/v1/student-acquisition/ambassador-client/${userDetails?._id}/update-recent-cohort`,
        { cohortId: cohortId }
      )
      if (response?.data?.success) {
        handleProceedClick(userDetails)
      } else {
        toast.error('Some error occured')
      }
    } catch (err: any) {
      toast.error(err?.message || 'Some error occured while Updating user')
    }
  }

  const handleProceedClick = async (enteredUserData: any) => {
    if (myProfileValue?.programType === PROGRAM_TYPE.CSC_PROGRAM) {
      handleBatchUserModal(enteredUserData)
    } else if (batchType === 'SKILLS') {
      paymentGatewayScriptForSkills()
    } else {
      paymentGatewayScript()
    }
  }

  const validate = () => {
    let valid = true
    const newErrors = { name: '' }
    const normalizedName = String(userData?.name ?? '').trim()

    if (!normalizedName || normalizedName.length < 2) {
      newErrors.name = 'Name is required'
      valid = false
    }

    setErrors(newErrors)
    return valid
  }

  const sendOtp = async () => {
    if (!validate()) return

    setIsSendingOtp(true)
    try {
      const response = await Client.post(
        `${process.env.REACT_APP_PP_API_BASE_URL}/v3/otp`,
        {
          phone: userData?.phone,
          countryCode: '+91',
          organizationId: process.env.REACT_APP_PP_PW_ORGANIZATION_ID,
        }
      )

      setOtpFail(false)

      if (response?.data?.success) {
        setIsProceed(true)
        toast.success('OTP sent successfully!')
        return true
      } else {
        toast.error('Failed to send OTP. Please try again.')
      }
    } catch (err: any) {
      toast.error('An error occurred while sending OTP.', err?.message || '')
      return false
    } finally {
      setIsSendingOtp(false)
    }
  }

  const handleResendOtp = async () => {
    const sent = await sendOtp()
    if (sent) {
      setTimer(10)
      setResendDisabled(true)
    }
  }

  useEffect(() => {
    if (isProceed && resendDisabled && timer > 0) {
      intervalRef.current = setInterval(() => {
        setTimer((prev) => prev - 1)
      }, 1000)
    }
    if (timer === 0) {
      setResendDisabled(false)
      clearInterval(intervalRef.current)
    }
    return () => clearInterval(intervalRef.current)
  }, [isProceed, timer, resendDisabled])

  const NUM_INPUTS = 6

  const inputRefs: React.RefObject<HTMLInputElement>[] = Array.from(
    { length: NUM_INPUTS },
    () => useRef<HTMLInputElement>(null)
  )

  const [otp, setOtp] = useState(new Array(NUM_INPUTS).fill(''))
  useEffect(() => {
    setOtpFail(false)
  }, [otp])

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-[5000]" onClose={() => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-50" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-8 md:translate-y-0 md:scale-95"
              enterTo="opacity-100 translate-y-0 md:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 md:scale-100"
              leaveTo="opacity-0 translate-y-8 md:translate-y-0 md:scale-95"
            >
              <Dialog.Panel className="sm:w-[480px] transform overflow-hidden sm:rounded-xl rounded-t-xl bg-white p-6 text-left align-middle shadow-xl transition-all md:flex fixed sm:bottom-auto bottom-0 w-full">
                {/* Close Button */}
                <button
                  onClick={onClose}
                  className="absolute right-5 top-5 text-gray-500 hover:text-black z-[1000] focus:outline-none"
                >
                  <XMarkIcon className="h-6 w-6" />
                </button>

                <div
                  className={`${
                    batchType === 'power_batch'
                      ? 'h-[65vh] overflow-scroll scrollbar-hide'
                      : 'w-full'
                  }`}
                >
                  {/* Image */}
                  <div className="flex justify-center mb-4">
                    {!isProceed ? <UserModal /> : <Phone />}
                  </div>

                  {/* Title & Subtext */}
                  {!isProceed ? (
                    <Dialog.Title className="text-center">
                      <Typography
                        color="#1B2124"
                        variant="heading4"
                        weight="semi-bold"
                      >
                        Who are you buying this batch for?
                      </Typography>
                    </Dialog.Title>
                  ) : (
                    <div className="flex items-center justify-center">
                      <Typography variant="subHeading" weight="semi-bold">
                        OTP Verification
                      </Typography>
                    </div>
                  )}
                  {!isProceed && (
                    <p className="text-center mt-1 mb-6">
                      <Typography
                        color="#3D3D3D"
                        variant="small"
                        weight="medium"
                      >
                        Batch access will be provided to submitted mobile number
                      </Typography>
                    </p>
                  )}

                  {/* Mobile Input */}
                  {!isProceed ? (
                    <>
                      <div
                        className="mb-4 w-full"
                        style={{ border: '1px solid #E0E0E0' }}
                      >
                        <InputField
                          fullWidth
                          variant={'outside'}
                          placeholder={'Enter your mobile'}
                          value={userData?.phone}
                          type="number"
                          preIcon={
                            <div className="flex">
                              <input
                                placeholder="country"
                                value={indianCountryCode + ' ' + '+91'}
                                disabled={'+91' === indiaDialCode}
                                className={`bold vertical-align text-center  w-[57px] px-0 border-none focus:outline-none focus:ring-0 text-[#A1A3A4]`}
                                list="countryCodes"
                                id="ctry_ipt"
                              />
                            </div>
                          }
                          className="focus:!outline-none focus:ring-0"
                          defaultValue={userData?.phone}
                          onChange={(e) => {
                            let value = e.target.value
                              .replace(/\D/g, '')
                              .slice(0, 10)

                            // If the first digit is 0–5, block it
                            if (value.length === 1 && /^[0-5]/.test(value)) {
                              value = '' // reset
                            }

                            setUserData((prev: any) => ({
                              ...prev,
                              phone: value,
                            }))
                          }}
                        />
                      </div>

                      {/* Name Input */}
                      <div className="mb-6 w-full">
                        <InputField
                          label="Full Name"
                          placeholder="Full Name"
                          type="text"
                          className="w-full"
                          fullWidth={true}
                          error={errors?.name ? true : false}
                          message={errors?.name}
                          onChange={(e) => {
                            const cleanedValue = e.target.value.replace(
                              /[^a-zA-Z ]/g,
                              ''
                            )
                            setUserData((prev: any) => ({
                              ...prev,
                              name: cleanedValue,
                            }))
                          }}
                          value={userData?.name || ''}
                        />
                      </div>

                      <Button
                        variant="primary"
                        className="w-full"
                        disabled={
                          !userData?.phone ||
                          !userData?.name ||
                          userData?.phone?.length < 10 ||
                          isSendingOtp
                        }
                        onClick={sendOtp}
                      >
                        Proceed
                      </Button>
                    </>
                  ) : (
                    <>
                      <div className="mb-2 w-full justify-items-center">
                        <div className="flex flex-col gap-2 items-center mb-6">
                          <div>
                            <Typography
                              variant="regular"
                              weight="medium"
                              className="text-center text-[#3D3D3D]"
                              component="h4"
                              color="#3D3D3D"
                            >
                              Please enter the 6 digit OTP sent to
                            </Typography>
                          </div>

                          <div className="mt-1 flex items-center gap-1">
                            <Typography
                              variant="small"
                              weight="semi-bold"
                              component="h4"
                              color="#3D3D3D"
                            >
                              {userData?.phone}
                            </Typography>
                            <EditIcon
                              className={'cursor-pointer w-4 h-4'}
                              onClick={() => {
                                setIsProceed(false)
                                setOtp(Array(NUM_INPUTS).fill(''))
                                clearInterval(intervalRef.current)
                                setTimer(10)
                                setResendDisabled(true)
                              }}
                            />
                          </div>
                        </div>
                        <OtpInputBoxes
                          wrongOTP={otpFail ? true : false}
                          setWrongOTP={setOtpFail}
                          NUM_INPUTS={NUM_INPUTS}
                          inputRefs={inputRefs}
                          otpState={false}
                          otp={otp}
                          setOtp={setOtp}
                        />
                      </div>
                      <div className="flex items-center justify-center my-6">
                        {!resendDisabled ? (
                          <Typography
                            variant="small"
                            weight="semi-bold"
                            component="p"
                            color="#5A4BDA"
                            className="cursor-pointer"
                            onClick={() => handleResendOtp()}
                          >
                            Resend OTP
                          </Typography>
                        ) : (
                          <Typography
                            variant="small"
                            weight="medium"
                            component="p"
                            color="#757575"
                          >
                            Resend OTP in {formatTime(timer)}
                          </Typography>
                        )}
                      </div>
                      <Button
                        variant="primary"
                        className="w-full"
                        disabled={otp?.join('')?.trim()?.length < 6 || urlSend}
                        onClick={getUser}
                        preIcon={urlSend && <Loader size="extra-small" />}
                      >
                        Verify OTP
                      </Button>
                    </>
                  )}

                  {/* Proceed Button */}

                  {/* Banner Note */}
                  {!isProceed &&
                    myProfileValue?.programType !==
                      PROGRAM_TYPE.CSC_PROGRAM && (
                      <div className="mt-4 flex items-start gap-2 rounded-lg bg-[#EDFCF2] p-3 text-sm">
                        🎉{' '}
                        <Typography color="#000000" variant="tiny">
                          Great! This is an assisted sale. You'll earn more than
                          normal coupon sales.
                        </Typography>
                      </div>
                    )}
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}
